import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    CreateInternalRoleAccessRuntype,
    CreateInternalRoleRuntype,
    DeleteInternalRoleAccessRuntype,
    InternalRoleAccessRuntype,
    InternalRoleRuntype,
    InternalUserRoleMembershipInsertRuntype,
    InternalUserRoleMembershipRuntype,
    UpdateInternalRoleRuntype,
} from './internalRoleBackendTypes';

export const internalRoleEndpoints = {
    'GET /internal-roles': endpoint({
        description: 'Get all roles',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(InternalRoleRuntype),
        actionPermission: () => 'CanViewInternalRoles',
    }),

    'POST /internal-roles': endpoint({
        description: 'Create a new role',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CreateInternalRoleRuntype,
        responseBody: InternalRoleRuntype,
        // Auto-invalidate the roles list after create
        invalidates: ['GET /internal-roles'],
        actionPermission: () => 'CanCreateInternalRole',
    }),

    'PATCH /internal-roles': endpoint({
        description: 'Update a role',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: UpdateInternalRoleRuntype,
        responseBody: InternalRoleRuntype,
        // Auto-invalidate the roles list after update
        invalidates: ['GET /internal-roles'],
        actionPermission: () => 'CanUpdateInternalRole',
    }),

    'DELETE /internal-roles/:roleId': endpoint({
        description: 'Delete a role by ID',
        pathParams: z.object({
            roleId: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.boolean(),
        // Auto-invalidate the roles list after delete
        invalidates: ['GET /internal-roles'],
        actionPermission: () => 'CanDeleteInternalRole',
    }),

    'GET /internal-role-access': endpoint({
        description: 'Get all role access entries',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(InternalRoleAccessRuntype),
        actionPermission: () => 'CanViewInternalRoles',
    }),

    'POST /internal-role-access': endpoint({
        description: 'Create a new role access entry',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CreateInternalRoleAccessRuntype,
        responseBody: InternalRoleAccessRuntype,
        // Auto-invalidate the role access list after create
        invalidates: ['GET /internal-role-access'],
        actionPermission: () => 'CanUpdateInternalRole',
    }),

    'DELETE /internal-role-access': endpoint({
        description: 'Delete a role access entry',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DeleteInternalRoleAccessRuntype,
        responseBody: z.boolean(),
        // Auto-invalidate the role access list after delete
        invalidates: ['GET /internal-role-access'],
        actionPermission: () => 'CanUpdateInternalRole',
    }),

    'GET /internal-user-role-memberships': endpoint({
        description: 'Get all user role memberships',
        pathParams: z.undefined(),
        queryParams: z.object({
            user_ids: z.array(z.string()),
        }),
        requestBody: z.undefined(),
        responseBody: z.record(z.string(), z.array(InternalUserRoleMembershipRuntype)),
        actionPermission: () => 'CanViewInternalUserRole',
    }),

    'PATCH /internal-user-role-memberships': endpoint({
        description: 'Update user role memberships',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            inserts: z.array(InternalUserRoleMembershipInsertRuntype),
            deletes: z.array(InternalUserRoleMembershipInsertRuntype),
        }),
        responseBody: z.array(InternalUserRoleMembershipRuntype),
        // Auto-invalidate the user role memberships list after update
        invalidates: ['GET /internal-user-role-memberships'],
        actionPermission: () => 'CanUpdateInternalUserRole',
    }),
};
